export const setBrowserTabTitle = (title: string, studyName: string) => {
  if (studyName) document.title = `${title} - ${studyName}`;
  else document.title = title;
};
export const openExternalMap = (lat: number, lng: number) => {
  if (!lat || !lng) return;
  window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
};

export const hostingUrl = () =>
  window.location.origin || `${window.location.protocol}//${window.location.host}`;

export const getUriQueryValue = (key: string): string => {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(key) ?? "";
  return value;
};

export const removeUriQueryParam = (key: string): void => {
  const params = new URLSearchParams(window.location.search);
  params.delete(key);
  const newSearch = params.toString();
  console.log(`path ${window.location.pathname}`);
  window.history.replaceState(
    null,
    "",
    newSearch ? `${window.location.pathname}?${newSearch}` : window.location.pathname,
  );
};

export const clearUriQuery = (): void => {
  window.history.replaceState(null, "", window.location.pathname);
};
